const ACCOUNTS_MAINNET = Object.freeze([
  'did:com:1xq366z9wpx2uzvr6d5e5g89hl3902km252n4nl',
  'did:com:1jyhpltwrnlccfs3puy95suvh8xlep38rckvn99',
  'did:com:1rkrnz57sf0474m6pyx453aghcyxpra3spm5sdg',
  'did:com:1cklr42dmhmkzmxt6ldcdvg0zvv4ue57ulhtkhh',
  'did:com:1adcxt5tjhud3gknw6jljllusk0w0q6l57v2y6d',
  'did:com:19esplhzvfxrrw7qcl56h0tu45ns948w354udjn',
  'did:com:1vs4v772rwrfa04vmsq5atc2awqj4pvxaeslzs5',
  'did:com:1vjmdsn9enwz5jmucr0q5xe5yr27mlnzmv2nqzx',
  'did:com:13y3jud5sn82d0yl7ud2q0r5yf7ughtd9ghj5vq',
  'did:com:13lsgrexen462t4c3fdc9va2fvlhaehf95t40am',
  'did:com:12m0cajektt2uf8xtgkv5c7cdxru2ra2nesy7dz',
  'did:com:1202rqeepqsy84e0wfqxfu0q3mufahh9zdxwtfn',
  'did:com:194tgyd92kenwfvc9tha6vkew2eaxrpl0sykgpv',
  'did:com:1sy5xetx8e02583jaxwhdysm9qngeg4387yn2mj',
  'did:com:159447efeqs3dwfhnlxwsrc8w6awqnxvz4vkxwh',
  'did:com:1xv6h9zcpsj06ztme6fttxh83zeedrtdvu0fcmn',
  'did:com:1c86asmft6f2c4d3l9fc5h9vuasdrphp9wsgw8w',
  'did:com:1q8mkesv6kcyr8ft69mvtmy6lxzfvn5y6ywhgh9',
  'did:com:1jywl63g45qahysytsylmsalnlsa4djlvtmvjgh',
  'did:com:1v7fqayg6r8vxf56ydp9ecyawysrcfp3c23nps0',
  'did:com:1k4ag3n2lcllmspmf799w404qa3lw0tkkqshw27',
  'did:com:1zkzy52fuewa2j90ndgtpsqtfnk7gmfnvvfg4ln',
  'did:com:1xuw233xtxdk0rzrtc729683c6zjattddtlglzu',
  'did:com:10c7pgucusnp74ccvtzxwq6v96fkzvy05sfl6k4',
  'did:com:195jfy8zzk35frg44zf8xzm2j7hnhnp9wuyaszv',
  'did:com:10mle4plg6q5jexgelzkllecel5trd279cl7y30',
  'did:com:1rtk7v8rfn9l4nn726xzvrk8wxpq50wx7hu7nwh',
  'did:com:1zjy4k9l5h48q456uswuqdmahcshju8kt68c3hd',
  'did:com:1s9yq6vlz9x0mdfruuzly9kmmzl9j5cjc8f6nh2',
  'did:com:1m6frjkvwv68lxvm7s7nuw6zsdd0g9ltv6q3w0u',
  'did:com:1pjm0fq8d7wma5erexur4m98yyzaeq2sjf9sx9r',
  'did:com:1ev582mr2pjcpqq4v3m0v46mc4dse9jhfzgrxrf',
  'did:com:1gfcy94ze6lumxyygd5d382mplzecny6hamyjvc',
  'did:com:1x3v9g0xkum9aqsnx4lxnc2rx4n4uaeh6rad35h',
  'did:com:1c44sw6srlnzc0njnqwckcj8hy37kj2x5xwxtf5',
  'did:com:1maypz2u8y82qe3c43d6muznuewpt99qrrkr8j4',
  'did:com:1342c5kfh83j85j5h7ey8h5skw9udu5n0e4yyhm',
  'did:com:1jkqs93dk9c04pd2mphp9k0e6n0se9eed2hww9e',
  'did:com:1ftk7nychaaufk8nn4p2dhf2dcajw29dp85lw47',
  'did:com:1fd2q96c3rtlc0d02ges4taa7zkqv7fhxk96tkn',
  'did:com:1g954xlqpjv96nrl75u2ulqjaw3juchxzuzxy7c',
  'did:com:109fup66yms0e559l54tjaawz0rsj2gxvqzlr9z',
  'did:com:10zsh8nmuuat805nh972el046sstesz8daveauy',
  'did:com:15jpk7u8hjsqkfmng5f57q9jt3se40es6qfh4kg',
  'did:com:1zeuwtrpfmpdgvzm53xlqjpyj95pl2h5fxfkzrn',
  'did:com:1jrurlx8snj7ls9vx4lkycvzzh33cjeyt4nev5j',
  'did:com:1c0dzxu5xfuw5ypxuuf0hkxxvt9ct49sp0up76k',
  'did:com:16h05vp73t4dnrunq02u9tplfw9a29hwzv649ua',
  'did:com:1vux58aq5yy4xt2sqreu6nf63yt33lgt6ckzq0a',
  'did:com:17qah7dqdf6rk7k0sn6u20rx6udahvp2mkw9ujy',
  'did:com:1xa9j9nwgk3rg000uxn9tttg25xc6y4vrvwmkcn',
  'did:com:13qmegexkc0lqv8m0p3vf7mft6er2v3pdu2w3y6',
  'did:com:18f7um5lxwqnjhksngw5m8c9qk6eq3cc6r2nxeq',
  'did:com:1ngc63em3wlwrnkk5ktppunastg88l7ct0glpm4',
  'did:com:1hf490ssj8z79xc39f0g9mkuknfhgseh8eetdul',
  'did:com:1n6j8cymcd2upaynlt74d6wqz3mdkc982zlge37',
  'did:com:182rfxy9qrcpqnzatw6meaqkcq54e89ztp2wnxv',
  'did:com:1ljq5ur2fcgnx4yaxvvte06qhslvqg0y5srtd9j',
  'did:com:1upmuv6vu9avrqe43dapq04ehcuu05ul8yyuhg5',
  'did:com:1a0uk7nxf20gzqcumqaylr5fmg8nxdzhyumvhng',
  'did:com:10vpmwkwuud2alyx9cwdtzjg4nd8e22lm6kql3t',
  'did:com:1ca24fxjad5xx44994dqtvzkcpz40jpxhytx4t4',
  'did:com:1ptlu99ej6ptyz834wfa2fvna5l6uum4nvwsjeu',
  'did:com:1zhl0de5h28ra6m5uy4cryqldxtj2gw4nnwjn0e',
  'did:com:169ays5eajpq3n42lysc2e4g8ypwd9z77hfgx9n',
  'did:com:1tt47usnr6qguaf5vn7zms9cq5mzvfxzrs0cg6z',
  'did:com:1743wetdlwzjqtzz8cjd54dmu6mqwfj2ephd48j',
  'did:com:1ml9dl2fepcp95l6pkhgzpck9vf790xr954zxht',
  'did:com:1cajw9x96j4dcz9cnr4e2hxd2ryd3c9ky7lzg0k',
  'did:com:1zuq2uch23m3kmvsmmlmagk3np634chrze0cde7',
  'did:com:1gffnsr4gqy246ye6gwevwqd56swymt46vvvluw',
  'did:com:1wlaeukqz2vn822cc7qqqscp00zner8q7tyym8y',
  'did:com:1dadm9krr7rlulk0heh2k0u96u8vva8kg6u33rn',
  'did:com:1zz7v326hmtzqf6y35at5z5aya9l3ktmsq2wy2s',
  'did:com:1yphjl4yj5r5rv3hckq5ujnj38y8lgywhssq96s',
  'did:com:19xnrnmp5pn7mpg6lusmtx5ezzl25n5st824rxp',
  'did:com:1xgj64949fvmqxckaafrs8qnnh2srn4lkmajx00',
  'did:com:199zvk2lfgwurfehuczz2whteg0gjspvq68mkw4',
  'did:com:1l7589w6mshkre3a7afrc5srqgdq566385n0tar',
  'did:com:1dr7et33lpydww7u03vsezqdj4csv0ehaw0rme5',
  'did:com:1mru95376m0ke6hplxvfy9x953vsulsztdzdkh7',
  'did:com:1yk2k43qprn5ggvdacda03n8mg6jp5j3dg2xcr5',
  'did:com:1ljfcdla9x7642gthjq6ct2qx5hv5hydnvsdacg',
  'did:com:14vuqkefx98n03kzlnsu4llc0yggphyy96gqna0',
  'did:com:1r86t9uznshkrlchf35xnpk8y7r5ys5hh6uehkg',
  'did:com:1csgk83ssrdauxlkhm2s97w4r9vgvc6mm4ysct7',
  'did:com:1mq88j9kqm76qtzpxvachrv2gm45e6s4kh2e7kl',
  'did:com:1z0znygkcsyjkqapmcyrcgtqcmnpn204d9pdga4',
  'did:com:15qzjqd9hx30muud4ygv3c4zrs3pyymt7qm7xrz',
  'did:com:1wf8p5ekeechzyw25kaaqeymdmff4stn3tmmnz8',
  'did:com:1n73k0ll5c4rkuvpxqreay60tmcuyayg625j8sz',
  'did:com:1v2mdfjtacwtm2qywzpchz5jhckycyznjx8d2v9',
  'did:com:1tjgxwd6te07fp09qs2gsa7hkg9ucfmmnlht0ce',
  'did:com:195a3dlxfamczpevhngh8uh2tdd445jt6yw565k',
  'did:com:1m5c45lq30lzwxp73stt82mlukg8yvzekjcukrj',
  'did:com:1052qyqx8c6qvx8njqnzj5e5xt0pcqx7q7svhh9',
  'did:com:14ff28mf66adwmxt3evzqz5609kua8awq77tr5v',
  'did:com:1md4660dynea76md62v4thp60uag26c5lmdvqr4',
  'did:com:1wcx60jyznjrpjr5wrepvwpv5vmyjw82u65etfl',
  'did:com:1t2zade4eye2wvf65wtqs5ekvtt65ytryfdgdnn',
  'did:com:1yqaunv0j33r462w43959lhr67fznxcat9z5lxn',
  'did:com:156h2whaprn8zc0ryz62wpprpgklxykm8ump7rq',
  'did:com:1g7jxvqr2uqj8f7lz7nuwttm07vll0dkcxgflfs',
  'did:com:183yl8g82asz8hawejuzp49ut9pq2lf0atq6saj',
  'did:com:12ja8ulvdunj7kd8lelhvctgs0xzrlyj8tz3d5a',
  'did:com:1ltrvw70gtxfqvzh6pyqnqwfpjw6vj6qy7nnuzs',
  'did:com:1uvkgv2n95vw4a623af6l6df6c9ngajumgklnn3',
  'did:com:166cctxwuuvqz7g02xm9hpty0l3ampjzdq7797w',
  'did:com:1chqrt0h7sf20mqayhgrat87zst4yvwkk65ulpy',
  'did:com:17gep7hem6dmh2qy6c03ztgfv4u7gm0l23y9734',
  'did:com:1cqlws43v30d9q4ml7es5a84grhn3eqgr950446',
  'did:com:17gweum4lfkehaysl6ev64d2vs7vclw7arnsp3a',
  'did:com:1lgkv54jel6plmn4dwp57ylqxge0v6pf2x76n3a',
  'did:com:1cf7k8dnhevj0pqrj4tal2p377s427e645nt0cc',
  'did:com:1a6kd5v8cyu2hxmgfdj3txk2y4cj07dqa840chw',
  'did:com:1rn99ye7d0lfpd6ucr7n07qndfdmfpcvwgdkld8',
  'did:com:1mked7ag9y226p0nl7yrmkl225ffjr3dpeffp8t',
  'did:com:197p2t6cueylr3kfhs7u5jfxdmpryw4zxq0pvqj',
  'did:com:15a0fh4w52d0e6ffrnls52rujl5ydcaq5wd4zcw',
  'did:com:12yqgkd5tjdfz7ccqlczecyd6zxr5swgdjhmp8t',
]);

const ACCOUNTS_TESTNET = Object.freeze([
  'did:com:1qq3hlgcgs3496u5xyxar2sd8yvd7m3yr9da8t6',
  'did:com:1zy2z428nt35w6ar93tvp6d9cxhrmrh9240ssth',
  'did:com:1rdfrpkys87xx5z5lh39f6um4jyceen4rkc3nzc',
  'did:com:1qzn8jnk0ku8fmlyenn96tj0mkh964t35uhgpyg',
]);

const ACCOUNTS_DEVNET = Object.freeze([
  'did:com:1mfddzjvr8vpeqdtm6fuay2nvnecuk9qa8usqq5',
  'did:com:133nf49v83dts7pq30csnnl7ul5unsvzz55qt20',
  'did:com:12hzcdgapfh9eyamd092mz0gp6gvl2regvsn0zq',
  'did:com:13zexjr23zcwuav2k4gfzvrmy2dkvaa9vhdgw06',
]);

const getAccounts = () => {
  switch (process.env.VUE_APP_LCD) {
    case 'https://lcd-mainnet.commercio.network':
      return ACCOUNTS_MAINNET;
    case 'https://lcd-testnet.commercio.network':
      return ACCOUNTS_TESTNET;
    case 'https://lcd-devnet.commercio.network':
      return ACCOUNTS_DEVNET;
    default:
      return ACCOUNTS_MAINNET;
  }
};

export default Object.freeze({
  ADDRESSES: getAccounts(),
  SEMAPHORE_ITEMS: 2,
});
